import styled, { css } from 'styled-components';
import React from 'react';
import { helperTextUtility, validationPseudoClassUtility } from '@/styles/utilities';

export const InputElement = styled.textarea`
  ${({ theme, ...props }) => {
    return css`
      // Base
      font-size: ${theme.typography.font_size.text_sm};
      padding: ${theme.spacing.sm};
      color: ${theme.color.dark};
      border-width: 2px;
      border-style: solid;
      display: block;
      width: 100%;
      appearance: none;

      // Style
      border-color: ${theme.color.neutral_400};
      border-radius: ${theme.radius.xs};
      outline: 0;

      // Transition
      transition: ${theme.transition.border_color};

      &::placeholder {
        color: ${theme.color.neutral_500};
      }

      &:hover {
        background: ${theme.color.neutral_100};
      }

      &:focus {
        border-color: ${theme.color.secondary_500};
        box-shadow: ${theme.box_shadow.sm};
      }

      + label,
      + input,
      + button {
        margin-top: 1rem;
      }

      ${validationPseudoClassUtility};
      ${helperTextUtility};
    `;
  }};
`;
